import React, { Fragment } from 'react';
import classes from './Burger.css';
import BurgerIngredient from './BurgerIngredients/BurgerIngredient.jsx';
import { withRouter } from 'react-router-dom';
import PriceTag from '../UI/PriceTag/PriceTag';


const burger = (props) => {
  let priceTag = null;
  if (props.location.pathname === '/build') {

    priceTag = <div className={classes.TagContainer}><PriceTag price={props.price} /></div>
  }

  let transformedIngredients = Object.keys(props.ingredients)
    .map(igKey => {
      return [...Array(props.ingredients[igKey])]
        .map((_, i) => {
          return <BurgerIngredient key={igKey + i} type={igKey} />
        })
    })
    .reduce((arr, el) => {
      return arr.concat(el);
    }, []);

  if (transformedIngredients.length === 0) {
    transformedIngredients = <p className={classes.burgerFillerText}>Please start adding ingredients!</p>
  }

  let burgerClasses = [classes.Burger];

  if (props.history.location.pathname !== '/build') {
    burgerClasses.push(classes.CheckoutBurger);
  }

  return (
    <Fragment>

      <div className={burgerClasses.join(' ')}>
        <BurgerIngredient key="breadTop0" type="breadTop" />
        {transformedIngredients}
        <BurgerIngredient key="breadBottom0" type="breadBottom" />
        {priceTag}
      </div>
    </Fragment>
  )
}

export default withRouter(burger); 


// WEBPACK FOOTER //
// ./src/components/Burger/Burger.jsx